import React, { useEffect, useState } from "react";
import pdficon from "./pdf.png";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

function LocalConveyance({ id, transportRows, setTransportRows, formData }) {
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);

  const totalLocalConveyance = transportRows.reduce(
    (acc, row) => acc + (parseFloat(row.travelAmount) || 0),
    0
  );

  // ✅ Update Row
  const handleTransportChange = (index, e) => {
    const { name, files, value } = e.target;
    const newTransportRows = [...transportRows];

    newTransportRows[index] = {
      ...newTransportRows[index],
      [name]: files && files.length > 0 ? files[0] : value,
    };

    setTransportRows(newTransportRows);
  };

  // ✅ Add Row
  const handleAddTransportRow = () => {
    setTransportRows([
      ...transportRows,
      {
        id: Date.now(),
        travelDate: "",
        origin: "",
        destination: "",
        travelAmount: "",
        transportMethod: "",
        receipt: "",
        isNew: true,
      },
    ]);
  };

  // ✅ Delete Row (only new ones can be deleted client-side)
  const handleRemoveTransportRow = (id) => {
    setTransportRows(transportRows.filter((row) => row.id !== id));
  };

  useEffect(() => {
    const fetchSettlement2 = async () => {
      try {
        const token = localStorage.getItem("authToken");
        const response = await fetch(
          `${API_BASE_URL}getsettlement?travel_id2=${id}`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const result = await response.json();
        if (result.status) {
          if (result.settlement2.length > 0) {
            const initialTransportRows = result.settlement2.map((settlement) => ({
              id: settlement.id,
              travelId: settlement.travel_id || "",
              travelDate: settlement.travelDate || "",
              origin: settlement.origin || "",
              destination: settlement.destination || "",
              travelAmount: settlement.travelAmount || "",
              transportMethod: settlement.transportMethod || "",
              receipt: settlement.receipt || "",
              isNew: false,
            }));

            setTransportRows(initialTransportRows);
          }
        } else {
          setError(result.message);
        }
      } catch (error) {
        console.error("Fetch error:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchSettlement2();
  }, [id, setTransportRows]);

  const handleDeleteRow = async (row) => {
    try {
      // ✅ If NEW row → just remove from state
      if (row.isNew) {
        setTransportRows((prev) => prev.filter((r) => r.id !== row.id));
        return;
      }

      // ✅ OLD row → call API
      const token = localStorage.getItem("authToken");

      const response = await fetch(
        `${API_BASE_URL}delete_settlement2/${row.id}`, // 👈 change API if needed
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      const result = await response.json();

      if (result.status) {
        // ✅ Remove from UI after success
        setTransportRows((prev) =>
          prev.filter((r) => r.id !== row.id)
        );
      } else {
        alert(result.message || "Delete failed");
      }
    } catch (error) {
      console.error("Delete error:", error);
    }
  };

  return (
    <>
      <center>
        <span className="btn btn-primary" style={{ fontSize: "12px" }}>
          Details of Local Conveyance
        </span>
      </center>

      <div
        className="transport-table-container"
        style={{ marginBottom: "20px", textAlign: "right" }}
      >
        {/* ✅ Add Row Button */}
        {formData?.is_submitted === 'NO' && (<button
          type="button"
          onClick={handleAddTransportRow}
          className="btn btn-primary"
          style={{ marginBottom: "10px" }}
        >
          + Add Row
        </button>)}

        <table className="expense-table">
          <thead>
            <tr className="header-row">
              <th style={{ textAlign: "center" }}>Travel Date</th>
              <th style={{ textAlign: "center" }}>Origin</th>
              <th style={{ textAlign: "center" }}>Destination</th>
              <th style={{ textAlign: "center" }}>Amount</th>
              <th style={{ textAlign: "center" }}>Transport Mode</th>
              <th style={{ textAlign: "center" }}>Receipt/Bill</th>
              <th style={{ textAlign: "center" }}>Action</th>
            </tr>
          </thead>
          <tbody>
            {transportRows.map((row, index) => (
              <tr key={row.id || index}>
                <td>
                  <input
                    type="date"
                    name="travelDate"
                    value={row.travelDate}
                    onChange={(e) => handleTransportChange(index, e)}
                    className="form-control input-font"
                    max={new Date().toISOString().split("T")[0]}
                  />
                </td>
                <td>
                  <input
                    type="text"
                    name="origin"
                    value={row.origin}
                    onChange={(e) => handleTransportChange(index, e)}
                    className="form-control input-font"
                    placeholder="From"
                  />
                </td>
                <td>
                  <input
                    type="text"
                    name="destination"
                    value={row.destination}
                    onChange={(e) => handleTransportChange(index, e)}
                    className="form-control input-font"
                    placeholder="To"
                  />
                </td>
                <td>
                  <input
                    type="number"
                    name="travelAmount"
                    value={row.travelAmount}
                    onChange={(e) => handleTransportChange(index, e)}
                    className="form-control input-font"
                    readOnly={formData?.rpt_mgr_status === "Approved"}
                  />
                </td>
                <td>
                  <select
                    name="transportMethod"
                    value={row.transportMethod}
                    onChange={(e) => handleTransportChange(index, e)}
                    className="form-control input-font"
                  >
                    <option value="">Select Mode</option>
                    <option value="bus">Bus</option>
                    <option value="train">Train</option>
                    <option value="auto">Auto</option>
                    <option value="taxi">Taxi</option>
                    <option value="Car">Own Vehicle-Car</option>
                    <option value="Bike">Own Vehicle-Bike</option>
                    <option value="Store_Vehicle">Store Vehicle</option>
                  </select>
                </td>
                <td>
                  <div className="d-flex align-items-center">
                    <input
                      type="file"
                      name="receipt"
                      accept="image/*,application/pdf"
                      onChange={(e) => handleTransportChange(index, e)}
                      className="form-control input-font me-2"
                    />
                    {row.receipt && typeof row.receipt === "string" && (
                      <a
                        href={row.receipt}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="position-relative"
                      >
                        {row.receipt.toLowerCase().endsWith(".pdf") ? (
                          <img
                            src={pdficon}
                            alt="Receipt PDF"
                            style={{ width: "50px", height: "50px", borderRadius: "4px" }}
                          />
                        ) : (
                          <img
                            src={row.receipt}
                            alt="Receipt"
                            style={{ width: "50px", height: "50px", borderRadius: "4px" }}
                          />
                        )}
                      </a>
                    )}
                  </div>
                </td>
                <td>
                  {formData?.is_submitted === 'NO' && (<button
                    type="button"
                    onClick={() => handleDeleteRow(row)}
                    className="btn btn-danger"
                  >
                    Delete
                  </button>)}
                </td>
              </tr>
            ))}
          </tbody>
          <tfoot>
            <tr>
              <td colSpan="3" style={{ textAlign: "right" }}>
                Total Amount:
              </td>
              <td>{totalLocalConveyance.toFixed(2)}</td>
              <td colSpan="3"></td>
            </tr>
          </tfoot>
        </table>
      </div>
    </>
  );
}

export default LocalConveyance;
